import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import SwitchMod from '../../../global/SwitchMod';
import LogoProveedor from '../LProveedores';
import ButtonEdit from '../../../global/ButtonEdit';
import { useDispatch } from 'react-redux';
import { eliminarProveedorAction } from '../../../ducks/proveedorDuck';

const columns = [
    { id: "RazonSocial", minWidth: 150, align: "center", label: 'Razón social' },
    { id: "RFC", minWidth: 150, align: "center", label: 'RFC' },
    { id: "Clave", minWidth: 150, align: "center", label: 'Clave' },
    { id: "Correo", minWidth: 150, align: "center", label: 'Correo' },
    { id: "Logo", minWidth: 150, align: "center", label: 'Logo' },
    { id: "Estatus", minWidth: 150, align: "center", label: 'Estatus' },
    { id: "Accion", minWidth: 30, align: "center", label: '' }
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function TProveedor({rows, onEditar = () =>{}}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const onEdit = (rowItem) =>{
    onEditar(rowItem)
  }
  const onChangeSwitch = (SwitchValue, SwitchCheked) =>{
    const valEstatus = SwitchCheked ? 1 : 0;
    dispatch(eliminarProveedorAction(SwitchValue, valEstatus)).then((Response) =>{
      
    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.IdProveedor}>
                      <TableCell align='center'>
                        {row.RazonSocial}
                      </TableCell>
                      <TableCell align="center">{row.RFC}</TableCell>
                      <TableCell align="center">{row.Nombre}</TableCell>
                      <TableCell align="center">{row.Email}</TableCell>
                      <TableCell align="center">
                        <LogoProveedor idProveedor={row.IdProveedor} titulo={row.RazonSocial}/>
                      </TableCell>
                      <TableCell align="center">
                        <SwitchMod
                          Name={`${row.RazonSocial}-Switch-${index}`}
                          Id={row.IdProveedor}
                          Estatus={row.Estatus}
                          onChangeSwitch={onChangeSwitch}
                        />
                      </TableCell>
                      <TableCell>
                        <ButtonEdit onClick={() =>{onEdit(row)}} />
                      </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}